
import { css } from 'lit';
export default css`
.image-navigation {
  display: flex;
  flex-direction: column;
}@media (min-width: 768px) {.image-navigation {
    flex-direction: row;
  }
}.image-navigation--item {
  position: relative;
}.image-navigation--item {
  margin-left: auto;
  margin-right: auto;
}.image-navigation--item {
  display: flex;
}.image-navigation--item {
  width: 100%;
}.image-navigation--item {
  flex-direction: row;
}.image-navigation--item {

    /* &::before {
      @apply absolute top-0 right-0 bottom-0 bg-red bg-no-repeat bg-cover;
      background-image: var(--image-nav-bg);
      background-position: center;
      width: 50%;
      content: '';
    } */
  }.image-navigation--button {
  width: 50%;
}.image-navigation--horizontal-grid {
  display: grid;
}.image-navigation--horizontal-grid {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}.image-navigation--horizontal-grid {
    -moz-column-gap: 0px;
         column-gap: 0px;
}.image-navigation--horizontal-grid {
  row-gap: 0.75rem;
}@media (min-width: 640px) {.image-navigation--horizontal-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}@media (min-width: 640px) {.image-navigation--horizontal-grid {
      -moz-column-gap: 1rem;
           column-gap: 1rem;
  }
}@media (min-width: 640px) {.image-navigation--horizontal-grid {
    row-gap: 1rem;
  }
}@media (min-width: 768px) {.image-navigation--horizontal-grid {
      -moz-column-gap: 1.5rem;
           column-gap: 1.5rem;
  }
}@media (min-width: 1366px) {.image-navigation--horizontal-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}.image-navigation__text {
  overflow: hidden;
}.image-navigation__text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
    -webkit-hyphens: auto;
        -ms-hyphens: auto;
            hyphens: auto;
  }.image-navigation__image{
    position: absolute;
    right: 0;
    left: 50%;
    width: 50%;
    top: 0;
    bottom: 0;
    -o-object-fit: cover;
       object-fit: cover;
    height: 100%;
    -o-object-position: center;
       object-position: center;
  }
.image-navigation--hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
`;